import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Flex } from '@goodrx/matisse-react';
import { ComponentRenderer, Container } from '@goodrx/x-core';
import { BlockConfig } from '../../../BlockConfig';
import { ThemeContext } from 'styled-components';
import { mediaMaxWidth } from '../../../../utils';
const StyledSmallFlex = styled(Flex)`
  display: none;
  ${mediaMaxWidth({
  md: css`
      display: flex;
    `
})}
`;
const StyledMediumFlex = styled(Flex)`
  ${mediaMaxWidth({
  md: css`
      display: none;
    `
})}
`;
export const LayoutBlock = props => {
  const {
    componentMap,
    className,
    mobileContentCollection,
    tabletContentCollection,
    inline,
    mobileConfig,
    tabletConfig
  } = props;
  const theme = useContext(ThemeContext);
  const smallItems = (mobileContentCollection === null || mobileContentCollection === void 0 ? void 0 : mobileContentCollection.items.filter(item => !!item)) || [];
  const mediumItems = (tabletContentCollection === null || tabletContentCollection === void 0 ? void 0 : tabletContentCollection.items.filter(item => !!item)) || [];
  const mobileConfigWithDefault = { ...(mobileConfig || {}),
    marginBottom: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom) || '16px'
  };
  const tabletConfigWithDefault = { ...(tabletConfig || {}),
    marginBottom: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom) || '16px'
  };
  return /*#__PURE__*/React.createElement(BlockConfig, {
    className: className,
    mobileConfig: mobileConfigWithDefault,
    tabletConfig: tabletConfigWithDefault
  }, /*#__PURE__*/React.createElement(Container, {
    gutter: inline ? 0 : theme.xSpace[4]
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(StyledSmallFlex, {
    width: "100%"
  }, smallItems.map((data, index) => /*#__PURE__*/React.createElement(ComponentRenderer, {
    key: `pageHeroSmallContent_${index}`,
    data: data,
    componentMap: componentMap
  }))), /*#__PURE__*/React.createElement(StyledMediumFlex, {
    alignContent: "stretch",
    width: "100%"
  }, mediumItems.map((data, index) => /*#__PURE__*/React.createElement(ComponentRenderer, {
    key: `pageHeroMediumContent_${index}`,
    data: data,
    componentMap: componentMap
  }))))));
};